import { ReactNode } from 'react';
import { MdOutlineNotificationsActive } from 'react-icons/md';

// Shown when no card is selected.
export const ActivityFeedDetailEmpty = (): ReactNode => (
  <div className='activity-feed-detail activity-feed-detail-empty'>
    <div className='activity-feed-detail-empty-icon'>
      <MdOutlineNotificationsActive />
    </div>
    <h3 className='activity-feed-detail-empty-title'>Select a notification to read it</h3>
    <p className='activity-feed-detail-empty-subtitle'>
      Pick anything from the list on the left and the full details will show up here.
    </p>
  </div>
);
